import React from 'react';
import { useApp } from '../App';
import SchoolRoutes from './SchoolRoutes';
import './dayBoardTheme.css';

// Top-level screen for the 'student' appState (see App.jsx's
// hydrateAsStudent) — a homeschool child's own view of the school module,
// distinct from the owner's Grove home and from a caregiver's SharedView.
// Themed with the Cedar Vale Day Board mockup's palette (day-board-theme,
// see dayBoardTheme.css) — Sam's primary daily surface, deliberately
// different-looking from the owner's plain Grove-styled School tabs.
export default function StudentView() {
  const { familyData, handleSignOut } = useApp() || {};
  const child = familyData?.activeChild;

  return (
    <div className="module-screen day-board-theme">
      <div className="module-header" style={{ borderBottom: '1px solid var(--line)' }}>
        <span className="home-header__title" style={{ fontFamily: 'var(--font-display)' }}>
          {familyData?.familyName || 'School'}{child?.preferred_name ? ` · ${child.preferred_name}` : ''}
        </span>
        <button className="btn btn--sm" style={{ marginLeft: 'auto' }} onClick={handleSignOut}>Sign out</button>
      </div>
      <div style={{ flex: 1, overflowY: 'auto', padding: '0 20px' }}>
        <div className="school-content">
          <SchoolRoutes />
        </div>
      </div>
    </div>
  );
}
